var image_upload_default = {
  "container": "gv3ue",
  "disabled": "_3kQKs",
  "imageInput": "KnCgy",
  "overlay": "f6WY5",
  "text": "wphJo",
  "shown": "ZWJHY",
  "hide": "FGjzN",
  "spinner": "mHAHa",
  "spin": "mUN0j"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
